import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CustomCursor from "./components/feature/CustomCursor";
import ScrollToTop from "./components/feature/ScrollToTop";
import SeoManager from "./seo/SeoManager";
import SchemaJsonLd from "./seo/SchemaJsonLd";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SeoManager />
        <SchemaJsonLd />
        <ScrollToTop />
        <CustomCursor />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;